import './AddTask.css';
import UrgencyWidget from './UrgencyWidget.js';
import minusIcon from '../../assets/images/minusIcon.png';
import plusIcon from '../../assets/images/plusIcon.png';
import Selector from '../components/Selector.js'
import TimeConstraintSelection from '../components/TimeConstraintSelection.js'
import updateUserData from '../../assets/functions/updateUserData'
import React, {useState} from "react";

function AddTask(props) {

    const [description, setDescription] = useState("");
    const [urgency, setUrgency] = useState(3);
    const [glowTask, setGlowTask] = useState(false);
    const [goalTag, setGoalTag] = useState((props.project ? props.project : 'unselected'));
    const [categoryTag, setCategoryTag] = useState('unselected');
    const [timeConstraintType, setTimeConstraintType] = useState(null);
    const [timeConstraintTime, setTimeConstraintTime] = useState(30);
    const [associatedMilestone, setassociatedMilestone] = useState((props.associatedMilestone ? props.associatedMilestone : ''))
    let taskStatus = (urgency === 5 ? "inProgress" : "notStarted")
    const handleNoteChange = (event) => {
        setDescription(event.target.value);
      };

      function clearFormData() {
        // setDescription("");
        // setUrgency(3);
        // setGlowTask(false);
        // setGoalTag(0);
        // setCategoryTag(0);
        // setTimeConstraintType(null);
        // setTimeConstraintTime("");
        props.setShowAddTask(false)
      }

      function clearFormAndKeep() {
        setDescription("");
      }

    return (
        <div className="addTaskOuterBlock">
            <p className="cancelText" onClick={() => props.setShowAddTask(false)}> cancel</p>
            <div className="addTaskInnerBlock">
            <p className="addTaskText"> add task</p>
            <div className="innerBlockSideLine"></div>
                <textarea
                    className="descriptionInput"
                    type="text"
                    id="description"
                    value={description}
                    onChange={handleNoteChange}
                    name="description"
                    spellCheck="false"
                />
                <div className="glowPowerDiv">
                    <p onClick={() => setGlowTask(true)} className={glowTask ? "glowPower activeGlowButton" : "glowPower inactiveGlowButton"}> glow </p>
                    <p onClick={() => setGlowTask(false)} className={glowTask ? "glowPower inactivePowerButton" : "glowPower activePowerButton"}> power </p>
                </div>
                <div className="dropdownsDiv">
                  {!glowTask &&
                    <Selector userProfile={props.userProfile} type="category" setData={setCategoryTag} className="dropdownContainer"/>
                  }
                    <div className="urgencyChange">
                        <img onClick={() => setUrgency(urgency-1)} className="minusUrgency" src={minusIcon} alt="circle with a minus icon inside"/>
                        <div className="urgencyWidget">
                            <UrgencyWidget taskUrgency={urgency}/>
                        </div>
                        <img onClick={() => setUrgency(urgency+1)} className="plusUrgency" src={plusIcon} alt="circle with a plus icon inside"/>
                    </div>
                    {glowTask &&
                    <Selector userProfile={props.userProfile} type="glowGoals" setData={setCategoryTag} className="dropdownContainer"/>
                    }
                    {!glowTask &&
                      <Selector userProfile={props.userProfile} type="projects" data={goalTag} setData={setGoalTag} className="dropdownContainer"/>
                    }
                </div>
                {props.addTaskGoal && 
                <div>
                  <p className="addTaskGoalText"> associated goal: </p>
                  <p className="addTaskGoalText"> {props.addTaskGoal} </p>
                </div>
                }
                <div className="dropdownsDiv2">
                  <Selector userProfile={props.userProfile} data={associatedMilestone} type="milestone" setData={setassociatedMilestone} className="dropdownContainer dropdownContainerLong"/>
                  <TimeConstraintSelection timeConstraintType={timeConstraintType} timeConstraintTime={timeConstraintTime} setTimeConstraintType={setTimeConstraintType} setTimeConstraintTime={setTimeConstraintTime} />
                </div>
                <p className="doneButton" onClick={async () =>
                {updateUserData("task", 
                  {"description": description, "goalTag": goalTag.toString(), "urgency": urgency, "category": categoryTag, "glowTask": glowTask, "timeConstraintType": timeConstraintType, "timeConstraintTime": timeConstraintTime, "associatedMilestone": associatedMilestone, "status": taskStatus},                  props.userProfile,
                  props.setUserProfile,
                  clearFormData
                )}}> add task and close</p>
                <p className="bottomDoneButton" onClick={async () =>
                {updateUserData("task", 
                  {"description": description, "goalTag": goalTag.toString(), "urgency": urgency, "category": categoryTag, "glowTask": glowTask, "timeConstraintType": timeConstraintType, "timeConstraintTime": timeConstraintTime, "associatedMilestone": associatedMilestone, "status": taskStatus},                  props.userProfile,
                  props.setUserProfile,
                  clearFormAndKeep
                )}}> add task and create another</p>
            </div>
        </div>
    )
}

export default AddTask;